export default __webpack_public_path__ + "static/media/Mirrored-Glass-Truck-Hero-1920px-640px.99f677d3.jpg";